import { Button } from '@creditornot/cb-button';
import { Modal } from '@creditornot/cbt-modal';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

type Props = {
  isDeleting: boolean;
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
};

const CancelButton = styled(Button).attrs({
  variant: 'secondary',
  size: 'small',
})``;

const DeleteButton = styled(Button).attrs({
  variant: 'secondaryNegative',
  size: 'small',
})``;

const UserDeletionModal = ({ isDeleting, isOpen, onClose, onDelete }: Props) => {
  const intl = useIntl();

  return (
    <Modal
      open={isOpen}
      onDismiss={onClose}
      title={intl.formatMessage({ id: 'userManagement.deleteUser' })}
      sizePreset="centered:medium"
      footer={
        <>
          <CancelButton onClick={onClose} disabled={isDeleting}>
            <FormattedMessage id="state.cancel" />
          </CancelButton>

          <DeleteButton onClick={onDelete} disabled={isDeleting} loading={isDeleting}>
            <FormattedMessage id="state.delete" />
          </DeleteButton>
        </>
      }
      footerStyle={{ justifyContent: 'flex-end', gap: 16 }}
    >
      <FormattedMessage id="userManagement.deleteUserConfirmation" />
    </Modal>
  );
};

export default UserDeletionModal;
